import { createFeature, createReducer, on } from '@ngrx/store';
import { ClaimActions } from '../actions/claim.actions';

export interface ClaimState {
  loading: boolean;
  error: string | null;
  response: any | null;
}

const initialState: ClaimState = {
  loading: false,
  error: null,
  response: null,
};

const reducer = createReducer(
  initialState,
  on(ClaimActions.claimReset, () => initialState),

  on(ClaimActions.claimReward, (state) => ({
    ...state,
    loading: true,
    error: null,
    response: null,
  })),

  on(ClaimActions.claimRewardSuccess, (state, response: {}) => ({
    ...state,
    loading: false,
    response,
  })),

  on(ClaimActions.claimRewardFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),
);

export const claimFeature = createFeature({
  name: 'claim',
  reducer,
});

export const {
  name,
  reducer: claimReducer,
  selectClaimState,
  selectLoading: selectClaimLoading,
  selectError: selectClaimError,
} = claimFeature;

export const selectClaimResponse = (state: ReturnType<typeof claimReducer>) => state.response;
